import { Component } from '@angular/core';
import {  Router } from '@angular/router';
import { BaseFpxROGridComponent } from '@fpx/core';
import { UnpostedtransactionService } from '../unpostedtransaction-service/unpostedtransaction.service';
//import { UnpostedtransactionService } from '../unpostedtransaction-service/unpostedtransaction.service';
import {UnpostedTransactiondtlsDisplayGridHelper } from './unposted-transactiondtls-display-grid.helper';

@Component({
 selector: 'app-unposted-transactiondtls-display-grid',
  templateUrl: './unposted-transactiondtls-display-grid.component.html',
  styleUrls: ['./unposted-transactiondtls-display-grid.component.scss'],
  providers: [
    UnpostedTransactiondtlsDisplayGridHelper
  ]
 })

export class UnpostedTransactiondtlsDisplayGridComponent extends BaseFpxROGridComponent<UnpostedtransactionService, UnpostedTransactiondtlsDisplayGridHelper> {
 constructor(
    protected unpostedTransactiondtlsDisplayGridHelper: UnpostedTransactiondtlsDisplayGridHelper,
    protected unpostedtransactiondtlsService: UnpostedtransactionService,
    _router:Router
  ) {
    super(unpostedTransactiondtlsDisplayGridHelper, _router);
  }


  protected override doPreInit(): void {
     this.setGridHeaders(['Date','Time','Reason','Reference No','Amount','Source Ref No']);
    this.setGridIdentifiers(['Date','time','reason','refnum','holdamt','sourcerefnum']);
    this.setGridColumnTypes(['String','String','String','String','String','String']);
    this.addGridDataService(this.unpostedtransactiondtlsService);
    // this.setGridTitle('unpostedtransactiondtls');
  //  this.addToolBar('icon', 'add', 'add', 'Add');
   // this.addToolBar('icon', 'edit', 'modify', 'Modify');
   // this.addToolBar('icon', 'refresh', 'refresh', 'Refresh');
    //this.setColumnWidths([40,40,40,40,40,40,40,40,40,40]);
  }

}
